'use strict';

(function(global) {

  // Способы масштабирования области предпросмотра
  const PREVIEW_SCALE = {
    FIT_HEIGHT: 'h',
    FIT_WIDTH: 'w',
    FIT_WINDOW: 'a',
  };

  // Стандартный отступ плейсхолдеров
  const PLACEHOLDER_MARGIN = 20;

  /**
   * Объект цикличный-итератор по направлениям вращения по сторонам света
   * @object Directions
   * @since 5.1.0.1523
   */
  const Directions = {
    index: 0,
    directions: [ 'N', 'E', 'S', 'W' ], //TODO: сделать константу
    next: function () {
      this.index = (this.index === this.directions.length - 1) ? 0 : ++this.index;
      return this.directions[ this.index ];
    },
    prev: function () {
      this.index = this.index ? --this.index : (this.directions.length - 1);
      return this.directions[ this.index ];
    },
  };

  /**
   * Действия над многостраничным документом, состоящим из изображений.
   * (Поворот, масштабирование и прокрутка)
   *
   * @since 5.7.0
   */
  class ImageActions extends global.BaseActions {

    constructor(context) {
      super();
      this._settings = new global.ImageDocumentPreviewSettings();
      this._initAttributes(context);
    }

    /**
     * @see Core.preview.BaseActions._initAttributes
     */
    _initAttributes(context) {
      super._initAttributes(context);
      this._html = this._jFrameContents.find('html');
      this._jImage = this._jFrameContents.find('.previewImage:first');
      this._jPlaceholder = this._jFrameContents.find('.placeholder');
      this._pageCount = 1; // Для одностраничных - всегда = 1. Будет переопределено для многостраничных документов.
      this._placeholderMargin = PLACEHOLDER_MARGIN; //ToDo: получать этот осттуп из разметки.
      this._imageInitialSize = {
        height: +(this._jImage.prop('naturalHeight') || this._jImage.height()),
        width: +(this._jImage.prop('naturalWidth') || this._jImage.width()),
      };
      this._recalculateContainerSize();
    }

    /**
     * Пересчитать размеры контейнера изображения
     *
     * @method _recalculateContainerSize
     * @private
     */
    _recalculateContainerSize() {
      const padding = this._placeholderMargin * 2;
      if (this._isIpad) {
        this._containerSize = {
          height: this._jFrame.parent().height() - padding,
          width: this._jFrame.parent().width() - padding,
        };
      } else {
        this._containerSize = {
          height: this._jFrame.height() - padding,
          width: this._jFrame.width() - padding,
        };
      }
    }

    /**
     * Повернуть страницы документа в указанном направлении
     *
     * @method _rotatePages
     * @param {string} direction 'N' - север, 'E' - восток, 'S' - юг 'W' - запад
     * @private
     * @return {Core.preview.scrolling}
     */
    _rotatePages(direction) {
      this._direction = direction;
      this._jPlaceholder
        .removeClass('N E W S')
        .addClass(direction);

      // Применим отступы если страницы оказываются повёрнуты на π/2
      let placeholderMarginCssProp = '';
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      if (shouldFlipHeightAndWidth) {
        const sizeDiff = this._imageInitialSize.width - this._imageInitialSize.height;
        if (this._direction === 'W') {
          placeholderMarginCssProp = `${sizeDiff - this._placeholderMargin/2}px auto 0`;
        } else {
          placeholderMarginCssProp = `${this._placeholderMargin/2}px auto 0`;
        }
      }

      this._jPlaceholder.css({
        'margin': placeholderMarginCssProp,
      });

      this.setScale();

      return this;
    }

    /**
     * Повернуть страницы документа по часовой стрелке
     *
     * @method rotateCW
     * @return {Core.preview.scrolling}
     */
    rotateCW() {
      this._rotatePages(Directions.next());
      return this;
    }

    /**
     * Повернуть страницы документа против часовой стрелки
     *
     * @method rotateCCW
     * @return {Core.preview.scrolling}
     */
    rotateCCW() {
      this._rotatePages(Directions.prev());
      return this;
    }

    /**
     * @see BaseActions.onResize
     */
    onResize() {
      this._recalculateContainerSize();
      // Если масштабирование относительно размера контейнера, то применим его заново
      if (!+this._settings.previewScale) {
        this.setScale();
      }
    }

    /**
     * @see BaseActions.setScale
     */
    setScale(key = this._settings.previewScale) {
      super.setScale(key);
      this._setScaleValueInDropdownAndButtons(key);

      // Получаем числовое значение масштаба
      const scale = (+key) / 100 || this._calculateScaleRelativeToContainer(key);

      this._recalculateSize(scale);
      return this;
    }

    /**
     * Установить текущий масштаб в выпадайке масштаба и на кнопках масштабирования.
     *
     * @method _setScaleValueInDropdownAndButtons
     * @param {string} key Масштаб
     * @private
     */
    _setScaleValueInDropdownAndButtons(key) {
      const isScaleAlreadySet = this._setScaleValueInDropdown(key);
      if (!isScaleAlreadySet) {
        $('.fit-to').removeClass('selected');
        const buttonKey = new Map([
          [PREVIEW_SCALE.FIT_HEIGHT, 'fitToHeight'],
          [PREVIEW_SCALE.FIT_WIDTH, 'fitToWidth'],
          [PREVIEW_SCALE.FIT_WINDOW, 'fitToWindow'],
        ]).get(key);
        if (buttonKey) {
          window.Core.preview.toolbar.buttons[buttonKey].turnOn();
        }
      }
    }

    /**
     * Установить масштаб относительно области предпросмотра.
     *
     * @method _calculateScaleRelativeToContainer
     * @param {string} key Способ масштабирования (одно из значений PREVIEW_SCALE).
     * @private
     * @return {number} Масштаб.
     */
    _calculateScaleRelativeToContainer(key) {
      let scale;
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      switch (key) {
        case PREVIEW_SCALE.FIT_HEIGHT: {
          const initSize = shouldFlipHeightAndWidth ? this._imageInitialSize.width : this._imageInitialSize.height;
          scale = this._containerSize.height / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WIDTH: {
          const initSize = shouldFlipHeightAndWidth ? this._imageInitialSize.height : this._imageInitialSize.width;
          scale = this._containerSize.width / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WINDOW: {
          scale = shouldFlipHeightAndWidth ?
            Math.min(this._containerSize.width / this._imageInitialSize.height, this._containerSize.height / this._imageInitialSize.width) :
            Math.min(this._containerSize.width / this._imageInitialSize.width, this._containerSize.height / this._imageInitialSize.height);
        }
      }
      return scale;
    }

    /**
     * Установить размер документа в соответствии с масштабом.
     *
     * @description Устанавливает css-свойста transform (scale), transform-origin и margin.
     * @method _recalculateSize
     * @param {number} scale Масштаб.
     * @private
     */
    _recalculateSize(scale) {
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      const initSize = shouldFlipHeightAndWidth ? this._imageInitialSize.height : this._imageInitialSize.width;
      const scaledImageWidthOverflow = (initSize * scale) > this._containerSize.width;
      let cssMargin = {
        top: this._placeholderMargin,
      };

      // Рассчитать отступ слева и справа для html, чтобы при изменении масштаба не появлялся горизонтальный скрол
      if (scaledImageWidthOverflow) {
        cssMargin.left = initSize * (scale - 1) / 2 + this._placeholderMargin;
        cssMargin.right = this._containerSize.width - initSize * (scale + 1) / 2;
      } else {
        const sideMargin = (this._containerSize.width - initSize) / 2 + this._placeholderMargin / 2;
        cssMargin.left = sideMargin;
        cssMargin.right = sideMargin;
      }

      let cssTransformOrigin = 'center top';

      // FIXы для ie, т.к. в нем при изменении масштаба размер контейнера не изменятеся
      if (WA.ENV.browser.name === 'IE') {
        // Если масштаб меньше 1, то устанавливаем точку вращения по вертикали на нижней границе элемента и добавляем отрицательный отступ сверху
        if (scale < 1) {
          cssTransformOrigin = 'center bottom';
          // Верхний и нижний отступы
          let holderBottomMargin = this._placeholderMargin;
          let holderTopMargin = this._placeholderMargin;
          const _jImage = this._jFrameContents.find('img:first');
          if (shouldFlipHeightAndWidth) {
            // Расчитаем верхний и нижний отступы по аналогии с расчетом при повороте, чтобы расчитать текущий размер контента
            let sizeDiff = _jImage.prop('naturalWidth') - _jImage.prop('naturalHeight');
            holderBottomMargin += sizeDiff;
            holderTopMargin += sizeDiff / 2;
          }
          cssMargin.top = (this._pageCount * (holderBottomMargin + this._imageInitialSize.height) + holderTopMargin) * (scale - 1);
        }

        // Если размер документа меньше размера окна, то скрываем скрол, т.к. справа появляются лишние отступы
        this._html.css({
          overflowX: scaledImageWidthOverflow ? 'auto' : 'hidden',
        });

      } else if (scale < 1) {
        // Данный хак убирает пустое место в предпросмотре снизу. Данный дефект проявляется везде, кроме IE.
        this._html.height(0);
      }

      // Изменить масштаб и указать отступы слева и справа, чтобы при изменении масштаба не появлялся горизонтальный скрол
      this._html.css({
        margin: '', // Без этого IE некорректно высчитывал отступы
        transform: `scale(${scale})`,
        transformOrigin: cssTransformOrigin,
      });

      requestAnimationFrame(() => {
        if (this._isIpad) {
          const padding = 20; // отступы страниц картинок 20px
          const frameBodyWidth = this._jFrame.contents().find('img:first').width() * scale + padding;
          let totalHeight = 0;
          this._jFrame.contents().find('body').children().each((index, element) => {
            totalHeight += element.offsetHeight + padding;
          });
          const minWidth = this._jFrame.parent().width() - 17;
          const frameBodyHeight = totalHeight * scale + padding;
          this._jFrame.css({
            backgroundColor: 'initial',
            height: `${frameBodyHeight}px`,
            marginBottom: '-4px',
            minWidth: `${minWidth}px`,
            width: `${frameBodyWidth}px`,
          });

          const marginLeft = minWidth > frameBodyWidth ? (minWidth - frameBodyWidth) / 2 : 10;
          this._html.css({
            margin: `10px 10px 10px ${marginLeft}px`,
            overflow: 'hidden',
            transformOrigin: 'left top',
          });
        } else {
          this._html.css({
            margin: `${cssMargin.top}px ${cssMargin.right}px auto ${cssMargin.left}px`,
          });
        }
      });
    }
  }

  global.ImageActions = ImageActions;
})(window.Core.preview);